var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { DataStore } from '../services/datastore.service';
let AppReset = class AppReset extends LitElement {
    constructor() {
        super();
        this._email = "";
        this.loading = false;
        this.sent = false;
        this.notification = undefined;
        this.keydownHandler = (e) => {
            if (e.keyCode == 13) {
                this.reset();
            }
        };
        this.datastore = DataStore.getInstance();
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('keydown', this.keydownHandler);
    }
    disconnectedCallback() {
        window.removeEventListener('keydown', this.keydownHandler);
        super.disconnectedCallback();
    }
    createRenderRoot() {
        return this;
    }
    updateValues() {
        this._email = document.getElementById("username").value;
    }
    reset() {
        this.updateValues();
        this.loading = true;
        this.datastore
            .resetUser(this._email)
            .then(() => {
            this.sent = true;
            this.notification = "Reset mail sent to your emailaddress if registered";
        })
            .catch((error) => {
            this.notification = JSON.parse(error.body).errortext;
        })
            .finally(() => {
            this.loading = false;
        });
    }
    clearNotification() {
        this.notification = undefined;
    }
    render() {
        return html `
      <div class="card">
        <div class="card-content">
          <div class="mt-2 mb-2 text-centered">

            <div class="field">
              <div class="control has-icons-left has-icons-right">
                <input id="username" class="input" type="text" placeholder="Email" />
                <span class="icon is-small is-left">
                  <i class="fas fa-at"></i>
                </span>
              </div>
            </div>

            <div class="container is-fluid p-0 is-clearfix">
              <button class="button is-primary is-pulled-left" @click="${this.reset}" ?disabled=${this.loading || this.sent}>
                <span class="icon"> ${this.loading ? html ` <i class="fas fa-circle-notch fa-spin"></i> ` : html ` <i class="fas fa-tools"></i> `} </span>
                <span>Send reset link</span>
              </button>
              <a href="login">
                <button class="button is-secondary is-pulled-right" ?disabled=${this.loading || this.sent}>
                  <span class="icon"><i class="fas fa-key"></i></span>
                  <span>Login</span>
                </button>
              </a>
            </div>

            ${this.notification ? html `
            <div class="notification ${this.sent ? "is-success" : "is-warning"} mt-4 has-text-centered">
              <button class="delete" @click="${this.clearNotification}"></button>
              ${this.notification}
            </div>
            ` : ''}

          </div>
        </div>
      </div>
    `;
    }
};
__decorate([
    state()
], AppReset.prototype, "loading", void 0);
__decorate([
    state()
], AppReset.prototype, "sent", void 0);
__decorate([
    state()
], AppReset.prototype, "notification", void 0);
AppReset = __decorate([
    customElement('app-reset')
], AppReset);
export { AppReset };
//# sourceMappingURL=anon_reset.js.map